// extracted by mini-css-extract-plugin
export default {"title":"appPageWrapper_title__traqy"};